module.exports = __webpack_public_path__ + "static/media/besties-bigheart.3d96dfa6.svg";